import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const PinIcon: SVGFC = ({ color = tailwindColors.red.DEFAULT, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3447_162253)">
        <path
          d="M7.06119 11.7747L12.225 16.9385C12.5474 17.261 13.0703 17.261 13.3928 16.9385C13.5478 16.7837 13.6348 16.5734 13.6348 16.3543V13.6684L18.5899 8.71322L19.0029 9.12616C19.231 9.35413 19.6006 9.35413 19.8287 9.12616C20.0567 8.89805 20.0567 8.5284 19.8287 8.30029L15.6994 4.17098C15.4713 3.94301 15.1017 3.94301 14.8735 4.17098C14.6456 4.39909 14.6456 4.76874 14.8735 4.99684L15.2865 5.40977L10.3313 10.3649H7.64537C7.42627 10.3649 7.21604 10.4519 7.06119 10.6069C6.73872 10.9294 6.73872 11.4521 7.06119 11.7747Z"
          fill={color}
        />
        <path
          d="M10.0563 14.7692L5.90362 18.9219C5.37845 19.4471 4.72048 19.8196 4 19.9997C4.18012 19.2792 4.55259 18.6212 5.07776 18.0961L9.23046 13.9434L10.0563 14.7692Z"
          fill="#CCCCCC"
        />
      </g>
      <defs>
        <clipPath id="clip0_3447_162253">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PinIcon
